<!-- @format -->

@if (enrolment?.state) {
  @if (enrolment.state === "PROCESSING") {
    <sis-tiny-badge variant="accent">
      {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.ENROLMENT_PROCESSING" | translate }}
    </sis-tiny-badge>
  }
  @if (enrolment.state === "ENROLLED") {
    <sis-tiny-badge variant="success">
      {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.ENROLMENT_ACCEPTED" | translate }}
    </sis-tiny-badge>
  }
  @if (enrolment.state === "REJECTED") {
    <sis-tiny-badge variant="danger">
      {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.ENROLMENT_REJECTED" | translate }}
    </sis-tiny-badge>
  }
  @if (enrolment.state === "ABORTED_BY_STUDENT" || enrolment.state === "ABORTED_BY_TEACHER") {
    <sis-tiny-badge variant="danger">
      {{ "ENROLMENTS.OPEN_UNIVERSITY_ENROLMENT.ENROLMENT_ABORTED" | translate }}
    </sis-tiny-badge>
  }
}
